import React from 'react';
import { Table } from 'reactstrap';
import PropTypes from 'prop-types';
import forms from 'constants/forms';
import CareAgentItem from './careAgentItem';

const CARE_AGENTS = forms.adminPanelsUser.userEdit.careAgents;

const CareAgents = ({ agents, label, displayProfType }) => (
  <div className="table-container care-agents">
    {agents && (
      <>
        <h5>{label}</h5>
        <Table borderless border="0" cellSpacing="0" cellPadding="0">
          <thead>
            <tr>
              <th>{label ? 'Physician' : 'Care Agents'}</th>
              <th>Details</th>
              {displayProfType && <td />}
            </tr>
          </thead>
          <tbody>
            {CARE_AGENTS.map((careAgent, index) => (
              <CareAgentItem
                key={index}
                field={careAgent}
                agents={agents}
                displayProfType={displayProfType}
              />
            ))}
          </tbody>
        </Table>
      </>
    )}
  </div>
);

CareAgents.propTypes = {
  agents: PropTypes.array,
  label: PropTypes.string,
  displayProfType: PropTypes.bool,
};

export default CareAgents;
